import { MailHistoryInterface } from '@/core/domain/mail/MailHistory/MailHistory.types';
import { Button, Collapse, Modal, Space, Typography } from 'antd';
import moment from 'moment';
import { v4 } from 'uuid';

import './emailHistoryModal.less';

interface EmailHistoryModalInterface {
  content?: MailHistoryInterface;
  onCancel: () => void;
}

export default function EmailHistoryModal({
  content,
  onCancel,
}: EmailHistoryModalInterface) {
  function downloadPDF(pdf: BlobPart, fileName?: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    let _fileName = '';

    if (fileName) {
      _fileName = fileName.replace(/\.[^/.]+$/, '');
    }

    _fileName = `${_fileName || v4()}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = _fileName;
    downloadLink.click();
  }

  const attachmentsOptions = content?.attachments?.map(
    ({ fileName, content }) => ({
      label: fileName,
      value: content,
    }),
  );

  return (
    <Modal
      className="email-modal"
      open={!!content}
      onCancel={onCancel}
      footer={<Button onClick={onCancel}>Fechar</Button>}
      title={
        <Space direction="vertical" style={{ width: '100%' }}>
          <Typography.Text strong>{content?.subject}</Typography.Text>

          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Typography.Text type="secondary" style={{ fontSize: '.8em' }}>
              de: {content?.from}
            </Typography.Text>

            <Typography.Text type="secondary" style={{ fontSize: '.8em' }}>
              {moment(content?.sentDate).format('DD/MM/YYYY')}
            </Typography.Text>
          </Space>
        </Space>
      }
      width={1000}
    >
      <div
        className="html-preview"
        dangerouslySetInnerHTML={{ __html: content?.message || '' }}
      />
      {!!content?.attachments && content.attachments.length > 0 && (
        <Collapse ghost style={{ width: '100%' }}>
          <Collapse.Panel
            header="Anexos"
            key="attachments"
            style={{ width: '100%' }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              {attachmentsOptions?.map((cur) => (
                <Button
                  type="link"
                  onClick={() => {
                    downloadPDF(cur.value, cur.label);
                  }}
                >
                  {cur.label}
                </Button>
              ))}
            </Space>
          </Collapse.Panel>
        </Collapse>
      )}
    </Modal>
  );
}
